import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  QueryList,
  signal,
  ViewChildren,
  WritableSignal
} from '@angular/core';
import {Subscription} from 'rxjs';
import {SectionDirective} from '../../directive/section.directive';
import {clearLandingSections, setLandingSections} from '../../registry/landing-sections.registry';
import {RichResultsService} from '../../rich-results/rich-results.service';

@Component({template: ''})
export abstract class AbstractLandingComponent implements AfterViewInit, OnDestroy {
  @ViewChildren(SectionDirective, {read: SectionDirective}) protected sections!: QueryList<SectionDirective>;

  private readonly sectionSubscription = new Subscription();
  private readonly richResultsService = inject(RichResultsService);
  protected isViewInitialized: WritableSignal<boolean> = signal<boolean>(false);

  ngAfterViewInit(): void {
    this.pushSectionsToSignal();

    const sub = this.sections.changes.subscribe(() => {
      this.pushSectionsToSignal();
    });
    this.sectionSubscription.add(sub);
    this.isViewInitialized.set(true);
  }

  protected pushSectionsToSignal(): void {
    const list = this.sections
      .toArray()
      .map(s => s.getMetadata())
      .filter(m => m && m.listable);

    setLandingSections(list);
  }

  ngOnDestroy(): void {
    this.sectionSubscription.unsubscribe();
    clearLandingSections();
    this.richResultsService.clear();
  }
}
